import { Component, Input, SimpleChanges, OnInit, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { TranslationService } from 'src/app/services/translation.service';
import { CertificationChartComponent } from './certification-chart/certification-chart.component';
import { CertificationTableComponent } from './certification-table/certification-table.component';
import { QaiLoadingComponent } from '@qai/ui';
import { ReportingDashboardService } from 'src/app/services/reporting-dashboard/reporting-dashboard.service';
import { ICertificationAssignmentStatsRequest } from 'src/app/interfaces/reportingV2/icertification-assignment-stats-request';
import { ICertificationAssignmentStatsResponse } from 'src/app/interfaces/reportingV2/icertification-assignment-stats-response';
import { AssignmentCategory } from 'src/app/interfaces/reportingV2/ipractice-assignment-stats-request';
import { AssignmentFilterComponent } from '../assignment-filter/assignment-filter.component';
import { withDemoModule } from 'src/app/utils/demo-mode/demo-mode-context.util';
import { AppConstants } from 'src/app/app-constants';

@Component({
  selector: 'app-certification-tab',
  templateUrl: './certification-tab.component.html',
  styleUrls: ['./certification-tab.component.scss'],
  standalone: true,
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: 'reportingV2',
    },
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    CertificationChartComponent,
    CertificationTableComponent,
    QaiLoadingComponent,
    AssignmentFilterComponent,
  ],
})
export class CertificationTabComponent implements OnInit, OnChanges {
  @Input() selectedAccount: { label: string; value: string } | null = null;
  @Input() selectedTeams: string[] = [];
  isTranslationLoaded: boolean = false;
  isLoading: boolean = false;
  isNetworkCallInprogress: boolean = false;
  certificationStats: ICertificationAssignmentStatsResponse[] = [];
  visibleCertificationStats: ICertificationAssignmentStatsResponse[] = [];
  currentFilter: AssignmentCategory = 'RECENT_ASSIGNMENTS';

  constructor(
    private translationService: TranslationService,
    private reportingDashboardService: ReportingDashboardService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.isTranslationLoaded && (changes['selectedAccount'] || changes['selectedTeams'])) {
      this.loadCertificationStats();
    }
  }

  ngOnInit() {
    this.translationService.loadScopedTranslation('reportingV2').then(() => {
      this.isTranslationLoaded = true;
      this.isLoading = false;
    });
  }

  onVisibleStatsChanged(visibleStats: ICertificationAssignmentStatsResponse[]): void {
    this.visibleCertificationStats = visibleStats;
  }

  onAssignmentChange(event: any) {
    this.currentFilter = event as AssignmentCategory;
    this.loadCertificationStats();
  }


  loadCertificationStats(): void {
    if (!this.selectedAccount?.value) {
      console.log('No account selected, skipping certification stats load');
      return;
    }

    this.isNetworkCallInprogress = true;

    // Handle "all" selection - if selectedTeams contains "all", pass empty array
    const teamUuids = this.selectedTeams.includes('all')
      ? []
      : this.selectedTeams;

    const request: ICertificationAssignmentStatsRequest = {
      accountUuid: this.selectedAccount.value,
      teamUuids: teamUuids,
      category: this.currentFilter,
    };

    this.reportingDashboardService
      .getCertificationAssignmentStats(request, withDemoModule(AppConstants.NEW_REPORTING_UI))
      .subscribe({
        next: (response) => {
          this.certificationStats = response;
          this.isNetworkCallInprogress = false;
          console.log('Certification stats loaded:', response);
        },
        error: (error) => {
          console.error('Error loading certification stats:', error);
          this.isNetworkCallInprogress = false;
          this.certificationStats = [];
          this.visibleCertificationStats = [];
        },
      });
  }
} 